// Inline style tags in segment text are numbered: <1>…</1> (mapped to b/i/u
// via the segment's tagMap). These helpers parse and diff them so the editor
// can flag, restore, and re-insert tags consistently.

// Ordered tag tokens in a string: [{ tag: '1', open: true }, …]. Numbered
// style tags (<1>…</1>) and line breaks (both <br/> and newline, modelled as a
// single self-closing token with tag 'br'). `nl` records the original form so
// a restore re-inserts the same character it removed.
export const parseTokens = (text) => {
    const out = [];
    if (typeof text !== 'string') return out;
    const decoded = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    const re = /<(\/?)(\d+)>|<br\s*\/?>|\n/gi;
    let m;
    while ((m = re.exec(decoded)) !== null) {
        if (m[2] === undefined) out.push({ tag: 'br', open: true, nl: m[0] === '\n' });
        else out.push({ tag: m[2], open: m[1] !== '/' });
    }
    return out;
};

// Tokens present in `from` but not matched by an equivalent token (same id +
// direction) in `against`. Multiset diff, returned in `from` order.
export const diffTokens = (from, against) => {
    const remaining = {};
    parseTokens(against).forEach((t) => {
        const k = `${t.tag}:${t.open}`;
        remaining[k] = (remaining[k] || 0) + 1;
    });
    const out = [];
    parseTokens(from).forEach((t) => {
        const k = `${t.tag}:${t.open}`;
        if (remaining[k] > 0) remaining[k] -= 1;
        else out.push(t);
    });
    return out;
};

export const tokenString = ({ tag, open, nl }) =>
    tag === 'br' ? (nl ? '\n' : '<br/>') : (open ? `<${tag}>` : `</${tag}>`);
